import React from 'react';
import styles from './AboutPreview.module.css';
import Button from '../../common/Button/Button';

function AboutPreview() {
  return (
    <section className={styles.aboutPreview}>
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.eyebrow}>Notre Philosophie</span>
          <h2 className={styles.title}>L'Esprit Maison Quinard</h2>
          <div className={styles.divider}></div>
          <p className={styles.text}>
            Chez Maison Quinard, nous sommes bien plus qu'une entreprise de construction. Nous sommes une équipe d'artisans passionnés par le bois, engagés pour la qualité et animés par un esprit coopératif unique.
          </p>
          <p className={styles.textHighlight}>
            Née de la volonté d'offrir des constructions bois d'excellence, notre philosophie est simple : bâtir durablement en valorisant les savoir-faire locaux et les ressources naturelles.
          </p>
          <div className={styles.ctaWrapper}>
            <Button to="/qui-sommes-nous" variant="primary">Découvrir notre histoire</Button>
          </div>
        </div>
        <div className={styles.imageSection}>
          <div className={styles.imageCard}>
            <img src="/images/ossaturebois2.jpg" alt="Atelier Maison Quinard" className={styles.imageMain} />
            <div className={styles.experienceBadge}>
              <span className={styles.years}>15+</span>
              <span className={styles.badgeText}>Années d'Excellence</span>
            </div>
          </div>
          <div className={styles.imageDecoration}></div>
        </div>
      </div>
    </section>

  );
}

export default AboutPreview;
